// Recovered compiled webpack factory 81356. Edit this function expression; run npm run build.
(e, t, r) => {
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "Image", {
      enumerable: !0,
      get: function () {
        return _;
      },
    }));
  let n = r(28140),
    i = r(49417),
    o = r(95155),
    a = i._(r(12115)),
    l = n._(r(47650)),
    s = n._(r(74841)),
    d = r(75040),
    u = r(20821),
    f = r(33455);
  r(94781);
  let c = r(79862),
    p = n._(r(71124)),
    g = r(83011),
    m = {
      deviceSizes: [640, 750, 828, 1080, 1200, 1920, 2048, 3840],
      imageSizes: [16, 32, 48, 64, 96, 128, 256, 384],
      path: "/_next/image",
      loader: "default",
      dangerouslyAllowSVG: !1,
      unoptimized: !1,
    };
  function h(e, t, r, n, i, o, a) {
    let l = null == e ? void 0 : e.src;
    e &&
      e["data-loaded-src"] !== l &&
      ((e["data-loaded-src"] = l),
      ("decode" in e ? e.decode() : Promise.resolve())
        .catch(() => {})
        .then(() => {
          if (e.parentElement && e.isConnected) {
            if (("empty" !== t && i(!0), null == r ? void 0 : r.current)) {
              let t = new Event("load");
              Object.defineProperty(t, "target", { writable: !1, value: e });
              let n = !1,
                i = !1;
              r.current({
                ...t,
                nativeEvent: t,
                currentTarget: e,
                target: e,
                isDefaultPrevented: () => n,
                isPropagationStopped: () => i,
                persist: () => {},
                preventDefault: () => {
                  ((n = !0), t.preventDefault());
                },
                stopPropagation: () => {
                  ((i = !0), t.stopPropagation());
                },
              });
            }
            (null == n ? void 0 : n.current) && n.current(e);
          }
        }));
  }
  function b(e) {
    return a.use ? { fetchPriority: e } : { fetchpriority: e };
  }
  let y = (0, a.forwardRef)((e, t) => {
    let {
        src: r,
        srcSet: n,
        sizes: i,
        height: l,
        width: s,
        decoding: d,
        className: u,
        style: f,
        fetchPriority: c,
        placeholder: p,
        loading: m,
        unoptimized: y,
        fill: v,
        onLoadRef: _,
        onLoadingCompleteRef: w,
        setBlurComplete: j,
        setShowAltText: x,
        sizesInput: S,
        onLoad: C,
        onError: O,
        ...P
      } = e,
      E = (0, a.useCallback)(
        (e) => {
          e && (O && (e.src = e.src), e.complete && h(e, p, _, w, j, y, S));
        },
        [r, p, _, w, j, O, y, S],
      ),
      R = (0, g.useMergedRef)(t, E);
    return (0, o.jsx)("img", {
      ...P,
      ...b(c),
      loading: m,
      width: s,
      height: l,
      decoding: d,
      "data-nimg": v ? "fill" : "1",
      className: u,
      style: f,
      sizes: i,
      srcSet: n,
      src: r,
      ref: R,
      onLoad: (e) => {
        h(e.currentTarget, p, _, w, j, y, S);
      },
      onError: (e) => {
        (x(!0), "empty" !== p && j(!0), O && O(e));
      },
    });
  });
  function v(e) {
    let { isAppRouter: t, imgAttributes: r } = e,
      n = {
        as: "image",
        imageSrcSet: r.srcSet,
        imageSizes: r.sizes,
        crossOrigin: r.crossOrigin,
        referrerPolicy: r.referrerPolicy,
        ...b(r.fetchPriority),
      };
    return t && l.default.preload
      ? (l.default.preload(r.src, n), null)
      : (0, o.jsx)(s.default, {
          children: (0, o.jsx)(
            "link",
            { rel: "preload", href: r.srcSet ? void 0 : r.src, ...n },
            "__nimg-" + r.src + r.srcSet + r.sizes,
          ),
        });
  }
  let _ = (0, a.forwardRef)((e, t) => {
    let r = (0, a.useContext)(c.RouterContext),
      n = (0, a.useContext)(f.ImageConfigContext),
      i = (0, a.useMemo)(() => {
        var e;
        let t = m || n || u.imageConfigDefault,
          r = [...t.deviceSizes, ...t.imageSizes].sort((e, t) => e - t),
          i = t.deviceSizes.sort((e, t) => e - t),
          o = null == (e = t.qualities) ? void 0 : e.sort((e, t) => e - t);
        return { ...t, allSizes: r, deviceSizes: i, qualities: o };
      }, [n]),
      { onLoad: l, onLoadingComplete: s } = e,
      g = (0, a.useRef)(l);
    (0, a.useEffect)(() => {
      g.current = l;
    }, [l]);
    let h = (0, a.useRef)(s);
    (0, a.useEffect)(() => {
      h.current = s;
    }, [s]);
    let [b, _] = (0, a.useState)(!1),
      [w, j] = (0, a.useState)(!1),
      { props: x, meta: S } = (0, d.getImgProps)(e, {
        defaultLoader: p.default,
        imgConf: i,
        blurComplete: b,
        showAltText: w,
      });
    return (0, o.jsxs)(o.Fragment, {
      children: [
        (0, o.jsx)(y, {
          ...x,
          unoptimized: S.unoptimized,
          placeholder: S.placeholder,
          fill: S.fill,
          onLoadRef: g,
          onLoadingCompleteRef: h,
          setBlurComplete: _,
          setShowAltText: j,
          sizesInput: e.sizes,
          ref: t,
        }),
        S.priority ? (0, o.jsx)(v, { isAppRouter: !r, imgAttributes: x }) : null,
      ],
    });
  });
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
